import styled from "styled-components";
import MainContext from '../../contexts/MainContext'
import { useContext } from 'react'
import { CommonButton } from '../../components/Buttons'
import { CLEAR_STATE, CLEAR_FILTERS } from '../../reducers/types'

const WrapperContainer = styled.div`
    display: flex;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 99999;
    background: rgba(0, 0, 0, 0.2);
    opacity: 1;
    backdrop-filter: blur(7px);
    -webkit-backdrop-filter: blur(7px);
    align-items: center;
    justify-content: center;
`
const Content = styled.div`
    display: flex;
    flex-flow: column;
    max-width: 385px;
    width: 100%;
    background: #fff;
    border-radius: 18px;
    padding: 40px 30px;

    @media(max-width: 550px) {
        width: 80%;
        max-height: fit-content;
        height: fit-content;
    }
`
const Title = styled.span`
    font-size: 32px;
    font-weight: bold;
    padding-right: 30px;
    margin-bottom: 13px;

    @media(max-width: 550px) {
        padding-right: 0;
        line-height: 38px;
    }
`
const Subtitle = styled.span`
    line-height: 22px;
    font-size: 16px;
    padding-right: 30px;
    margin-bottom: 30px;
`
const ButtonsWrappers = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media(max-width: 550px) {
        flex-flow: column;
        
        span {
            margin-top: 10px;
        }
    }

    a {
        color: #000;
    }
`
const SuccessMessageSent = (props) => {

    const { 
        userData: { dispatch: userDispatch },
        projectUser: { dispatch: projectDispatch },
        material: { dispatch: dispatchMaterial } 
    } = useContext(MainContext)

    const goHome = () => {

        userDispatch({
            type: CLEAR_STATE
        })

        projectDispatch({
            type: CLEAR_STATE
        })

        dispatchMaterial({
            type: CLEAR_FILTERS
        })

        props.navigate("/")

    }

    return (
        <WrapperContainer>
            <Content>
                <Title> Seu orçamento foi salvo com sucesso </Title>
                <Subtitle> Você pode aguardar o nosso contato ou continuar para informar mais detalhes do seu projeto. </Subtitle>
                <ButtonsWrappers>
                    <CommonButton text="Voltar para home" onClick={goHome} />
                </ButtonsWrappers>
            </Content>
        </WrapperContainer>
    )

}

export default SuccessMessageSent